module.exports = __webpack_public_path__ + "img/53.cc2c9c56.jpg";